$(document).ready(function() {
    if (window.location.href.indexOf("https://omnicharge") > -1) {
      $(document.body).addClass('us-local');
    }
});
$(document).ready(function() {
    if (window.location.href.indexOf("https://www.") > -1) {
      $(document.body).addClass('us-local');
    }
});

$(document).ready(function() {
    if (window.location.href.indexOf("https://ca.") > -1) {
      $(document.body).addClass('canada-local');
    }
});

$(document).ready(function() {
    if (window.location.href.indexOf("https://jp.") > -1) {
      $(document.body).addClass('japan-local');
    }
});
$(document).ready(function() {
    if (window.location.href.indexOf("https://uk.") > -1) {
      $(document.body).addClass('uk-local');
    }
});
$(document).ready(function() {
    if (window.location.href.indexOf("https://eu.") > -1) {
      $(document.body).addClass('eu-local');
    }
});
$(document).ready(function() {
    if (window.location.href.indexOf("https://au.") > -1) {
      $(document.body).addClass('au-local');
    }
});
$(document).ready(function() {
    if (window.location.href.indexOf("https://intl.") > -1) {
      $(document.body).addClass('intl-local');
    }
});
$(document).ready(function() {
    if (window.location.href.indexOf("aca=") > -1) {
      $(document.body).addClass('cstm-promo-info');
    }
});